import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Clos un workflow'.
 */
export class CompleteWorkflowActionData extends BaseActionData {
    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.CompleteWorkflow);
    }

    /**
     * Retourne une copie d'une instance de CompleteWorkflowActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: CompleteWorkflowActionData) {
        if (!!other) {
            const instance = new CompleteWorkflowActionData();
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
